import { createRouter, createWebHashHistory } from 'vue-router'
import Layout from '@/views/login/logout.vue';

const routes = [
  {
    path: '/',
    component: () => import('@/views/injection/equipment'),
    meta:{
      requiresAuth:true
    }
  },
  {
    path: '/login',
    component: () => import('@/views/login/index.vue'),
  },
  {
    path: '/injection',
    component: () => import('@/App.vue'),
    meta:{
      requiresAuth:true
    }
  },
  {
    path: '/mold',
    component: () => import('@/views/injection/mold/sample.vue'),
    meta:{
      requiresAuth:true
    }
  },
  {
    path: '/ruler',
    component: () => import('@/views/injection/mold/ruler.vue'),
    meta:{
      requiresAuth:true
    }
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes: routes
})

// 路由守卫，检查是否登录
router.beforeEach((to, from, next) => {
  const isAuthenticated = localStorage.getItem('userLoggedIn');
  if (to.meta.requiresAuth && !isAuthenticated) {
    next(`/login?redirect=${to.path}`);
  } else {
    next();
  }
});

export default router